import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {FormBase} from './form-base';
import {FormsControlService} from './forms-control.service';

@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss']
})
export class DynamicFormComponent implements OnInit {

  @Input() fields: FormBase<string>[] = [];
  @Input() curIndex;
  @Output() formEvents: EventEmitter<any> = new EventEmitter<any>();
  form: FormGroup;
  payLoad = '';

  constructor(private fcs: FormsControlService) {
  }

  ngOnInit() {
    this.form = this.fcs.toFormGroup(this.fields);
  }

  onSubmit() {
    this.payLoad = JSON.stringify(this.form.getRawValue());
  }
  onForm() {
    this.payLoad = this.form.getRawValue();
    this.formEvents.emit({
      form: this.form,
      payload: this.payLoad,
      formIndex: this.curIndex
    });
  }
  customChange(event) {
    this.payLoad = this.form.getRawValue();
    this.formEvents.emit({
      form: this.form,
      payload: this.payLoad,
      formIndex: this.curIndex
    });
  }
}
